import { render, staticRenderFns } from "./FormAddressEdit.vue?vue&type=template&id=23267c8a"
import script from "./FormAddressEdit.vue?vue&type=script&lang=js"
export * from "./FormAddressEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports